module.exports = __webpack_public_path__ + "media/ad_preview/caranddriver-bf98cf98.png";